exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cf .open-pips-details .customer-link-item .data-key,.hitachi .open-pips-details .customer-link-item .data-key{color:#333}.open-pips-details .customer-link-item .data-key{color:#367c2b;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/pip/shared/components/pip-details.scss
// module id = 5094
// module chunks = 0